import React, { useMemo } from "react";
import classNames from "classnames";
import useTranslation from "~/app/hooks/useTranslation";
import classes from "./style.module.scss";

export type ProgressHeaderProps = {
  step: 1 | 2 | 3;
};

export type ProgressHeaderComponent = React.FC<ProgressHeaderProps>;

const ProgressHeader: ProgressHeaderComponent = ({ step }) => {
  const { t } = useTranslation("workorder.create");

  const stepTitle = useMemo(() => {
    if (step === 1) {
      return t("steps.machineAndDepartment");
    }
    if (step === 2) {
      return t("steps.responsibleAndSchedule");
    }
    return t("steps.workContent");
  }, [step, t]);

  const pillClass = (pillStep: 1 | 2 | 3) => {
    if (step === pillStep) {
      return classes["pill--active"];
    }
    if (step > pillStep) {
      return classes["pill--completed"];
    }
    return classes["pill--inactive"];
  };

  return (
    <div className={classes.progress}>
      <div className={classes.pills}>
        <span
          className={classNames(classes.pill, pillClass(1))}
          aria-hidden
        />
        <span
          className={classNames(classes.pill, pillClass(2))}
          aria-hidden
        />
        <span
          className={classNames(classes.pill, pillClass(3))}
          aria-hidden
        />
      </div>
      <p className={classes["step-label"]}>
        {t("stepLabel", { current: step, total: 3, title: stepTitle })}
      </p>
    </div>
  );
};

export default ProgressHeader;
